import {
  REQUEST_VIDEOS,
  RECEIVE_VIDEOS,
  UPDATE_VIDEOS,
  RECEIVE_VIDEO,
  RECEIVE_TRANSCRIPT,
  RECEIVE_VIDEO_PRODUCTS_ALL,
  RECEIVE_SINGLE_VIDEO_PRODUCTS,
  UPDATE_VIDEO_PARAMS,
  RECEIVE_SENTIMENT,
  RECEIVE_DEMOGRAPHICS,
  REQUEST_VIP_VIDEO_NOTE,
  RECEIVE_VIP_VIDEO_NOTE,
  REQUEST_VIP_INFLUENCER_VIDEO_URL,
  RECEIVE_VIP_INFLUENCER_VIDEO_URL,
  REQUEST_VIP_INFLUENCER_DROPBOX_VIDEO_URL,
  RECEIVE_VIP_INFLUENCER_DROPBOX_VIDEO_URL,
  REQUEST_VIDEO_AUTHOR,
  RECEIVE_VIDEO_AUTHOR,
  RESET_FILTERS_VIDEOS,
  ALL_TRANSCRIPT_STATUS,
  DOWNLOAD_ALL_TRANSCRIPT,
  ALL_TRANSCRIPT_KEYWORDS,
  SET_VIDEO_PAGE,
  RESET_VIDEO_PAGE,
  SET_VIDEO_TYPE,
  UPDATE_ADD_COMPETITOR_VIDEO,
  VIDEO_PAGE_STATES,
  SET_VIDEO_DETAIL_BREADCRUMB,
  SET_VIDEO_UPLOAD_DETAIL,
  PUBLISHED_PAGE_STATES,
  UPDATE_COPY,
  REQUEST_FOR_VIDEO_REANALYSIS,
  RECIEVE_REANALYSIS_FOR_VIDEO,
  UPDATE__REANALYSIS_FOR_VIDEO,
  VIDEO_CAMPAIGN_STATES,
  UPDATE_CAMPAIGN_SORTING,
} from "./VideoActions";
import { RECEIVE_CURRENT_SESSION } from "../../Entry/session_actions";

export const videos = (state = [], { type, videos, video }) => {
  switch (type) {
    case REQUEST_VIDEOS:
      return [];
    case UPDATE_VIDEOS:
    case RECEIVE_VIDEOS:
      return videos;
    case RECEIVE_VIDEO:
      return [video];
    default:
      return state;
  }
};
const lodash = require("lodash");
const initialtranscriptState = {
  transcripts: [],
};
export const transcript = (
  state = initialtranscriptState,
  { type, transcripts }
) => {
  switch (type) {
    case RECEIVE_TRANSCRIPT:
      return { ...state, transcripts: state.transcripts.concat(transcripts) };
    default:
      return state;
  }
};

export const videoProductsAll = (state = [], payload = {}) => {
  const { type, videoProductsAll } = payload;
  switch (type) {
    case RECEIVE_VIDEO_PRODUCTS_ALL:
      return { ...state, videoProductsAll };
    default:
      return state;
  }
};

export const singleVideoProducts = (
  state = [],
  { type, singleVideoProducts }
) => {
  switch (type) {
    case RECEIVE_SINGLE_VIDEO_PRODUCTS:
      return singleVideoProducts;
    default:
      return state;
  }
};

export const filters = {
  platform: [],
  note: [],
  // topic: {},
  demographic: {
    age_range: [],
    ethnicity: [],
    gender: [],
  },
  scene: {},
  pov: [],
  influencer: [],
  category: [],
  product: [],
  brand: [],
  audio_labels: [],
  brand_safety: {
    visual_content: [],
    foul_language: [],
  },
  language: [],
  views: {
    radio: true,
    value: null,
  },
  sponsored: {
    sponsorship: [],
    sponsored_by: [],
  },
};

const dates = {
  startDate: null,
  endDate: null,
};

export const _nullParams = {
  sort: "created_at",
  desc: true,
  search: "",
  page: 1,
  tab: "My Videos",
  filters: {
    ...filters,
    topic: {
      topics: [],
      subTopics: [],
    },
  },
  dates,
  trending: false,
  isFlaggedTab: false,
  isTrashTab: false,
  isFavoriteTab: false,
  isCampaignTab: false,
};

export const videoParams = (state = _nullParams, { type, params }) => {
  switch (type) {
    case RESET_FILTERS_VIDEOS:
      return { ...state, filters: _nullParams.filters };
    case UPDATE_VIDEO_PARAMS:
      return { ...state, ...params };
    case RECEIVE_CURRENT_SESSION:
      return _nullParams;
    default:
      return state;
  }
};

const _nullData = {
  totalPages: 1,
  loading: false,
  transcriptView: false,
  count: 0,
  yesterday: [],
  filters,
  sentiment: { positive: [], negative: [] },
  demographics: {},
  loaded_for: null,
  showVideoPage: false,
  videoType: "My Videos",
  addCompetitorVideo: false,
};

export const videoData = (
  state = _nullData,
  { type, data, sentiment, demographics, videoType, addCompetitorVideo }
) => {
  switch (type) {
    case REQUEST_VIDEOS:
      return { ...state, loading: true };
    case UPDATE_VIDEOS:
    case RECEIVE_VIDEOS:
      return {
        ...data,
        showVideoPage: state.showVideoPage,
        addCompetitorVideo: state.addCompetitorVideo,
        demographics: state.demographics,
      };
    case RECEIVE_SENTIMENT:
      return { ...state, sentiment };
    case RECEIVE_DEMOGRAPHICS:
      return { ...state, demographics };
    case SET_VIDEO_PAGE:
      return { ...state, showVideoPage: true };
    case RESET_VIDEO_PAGE:
      return { ...state, showVideoPage: false };
    case SET_VIDEO_TYPE:
      return { ...state, videoType };
    case UPDATE_ADD_COMPETITOR_VIDEO:
      return { ...state, addCompetitorVideo };
    default:
      return state;
  }
};

const _nullInfluencerVideoNote = {
  loading: false,
  body: {},
};

export const vipInfluencerVideoNote = (
  state = _nullInfluencerVideoNote,
  payload
) => {
  const { type, note } = payload;

  switch (type) {
    case REQUEST_VIP_VIDEO_NOTE:
      return { ...state, loading: true };
    case RECEIVE_VIP_VIDEO_NOTE:
      return { ...state, loading: false, body: note };
    default:
      return state;
  }
};

const _nullState = {
  video_url: null,
  loadingYoutubeVideoUrl: false,
};

export const vipInfluencerVideoURL = (
  state = _nullState,
  { type, video_url }
) => {
  switch (type) {
    case REQUEST_VIP_INFLUENCER_VIDEO_URL:
      return { ...state, loadingYoutubeVideoUrl: false };
    case RECEIVE_VIP_INFLUENCER_VIDEO_URL:
      return { ...state, video_url, loadingYoutubeVideoUrl: true };
    default:
      return state;
  }
};

const _nullDropbox = {
  dropbox_video: null,
  loadingDropboxVideoUrl: false,
};

export const vipInfluencerDropboxVideo = (
  state = _nullDropbox,
  { type, dropbox_video }
) => {
  switch (type) {
    case REQUEST_VIP_INFLUENCER_DROPBOX_VIDEO_URL:
      return { ...state, loadingDropboxVideoUrl: false };
    case RECEIVE_VIP_INFLUENCER_DROPBOX_VIDEO_URL:
      return { ...state, dropbox_video, loadingDropboxVideoUrl: true };
    default:
      return state;
  }
};

const _nullVideoAuthor = {
  body: {},
  loadingVideoAuthor: false,
};

export const videoAuthor = (state = _nullVideoAuthor, payload) => {
  const { type, videoAuthor } = payload;

  switch (type) {
    case REQUEST_VIDEO_AUTHOR:
      return { ...state, loadingVideoAuthor: false };
    case RECEIVE_VIDEO_AUTHOR:
      return {
        ...state,
        body: videoAuthor,
        loadingVideoAuthor: true,
      };
    default:
      return state;
  }
};

export const toggleTranscript = (state = false, { type, data }) => {
  switch (type) {
    case ALL_TRANSCRIPT_STATUS:
      return data;
    default:
      return state;
  }
};

const _nullTranscript = {
  downloadState: false,
  loadingTranscriptPdf: false,
  fileType: "pdf",
};
export const downloadTranscript = (
  state = _nullTranscript,
  { type, downloadState, loadingTranscriptPdf, fileType }
) => {
  switch (type) {
    case DOWNLOAD_ALL_TRANSCRIPT:
      return { ...state, downloadState, loadingTranscriptPdf, fileType };
    default:
      return state;
  }
};

export const keywordsOnly = (state = true, { type, status }) => {
  switch (type) {
    case ALL_TRANSCRIPT_KEYWORDS:
      return status;
    default:
      return state;
  }
};

const _nullPageState = {
  isCategoryPage: true,
  videoReportedAsFlagged: false,
  successfullyUnFlagged: false,
  successfullyUnFavorite: false,
  flaggedChecks: false,
  favoriteChecks: false,
  flaggedVideosCheckList: [],
  favVideosCheckList: [],
  flagSelectAll: false,
  favSelectAll: false,
  publishSelectAll: false,
  confirmUnflag: false,
  deleteChecks: false,
  restoreChecks: false,
  deleteVideosCheckList: [],
  restoreVideosCheckList: [],
  deleteSelectAll: false,
  confirmDelete: false,
  confirmRestore: false,
  trashConfirmationModal: false,
  successfullyDeleted: false,
  successfullyRestored: false,
  confirmUnfav: false,
  isVideoDetailPage: false,
  downloadVideoChecks: false,
  downloadVideosCheckList: [],
  publishVideoChecks: false,
  publishVideosCheckList: [],
  //States for Handling tutorial
  tutorialStates: {
    isTutorial: false,
    activeTutorial: "video-detail",
    activeStep: 1,
  },
  campaigns: [],
  isCampaignListPage: false,
  showSinleSwirll: false,
  openSinglePublish: false,
  campaignsState: {
    tab: "ACTIVE",
    tabs: [
      { name: "Active Campaigns", value: "ACTIVE" },
      { name: "Past Campaigns", value: "PAST" },
      { name: "Draft Campaigns", value: "DRAFT" },
    ],
    breadcrumbs: [],
    showCampaignHeader: false,
    campaignName: "",
    campaignId: "",
    showCampaignDetail: false,
    showCampaignStep: false,
  },
  campaignSortBy: "OLD",
};

export const videoPageStates = (
  state = _nullPageState,
  { type, status, campaignSortBy }
) => {
  switch (type) {
    case VIDEO_PAGE_STATES:
      return { ...state, ...status };
    case VIDEO_CAMPAIGN_STATES:
      return {
        ...state,
        campaignsState: { ...state.campaignsState, ...status },
      };
    case UPDATE_CAMPAIGN_SORTING:
      return {
        ...state,
        campaignSortBy,
      };
    default:
      return state;
  }
};

const _nullPublishedStates = {
  isCategoryPage: true,
};

export const PublishedPageStates = (
  state = _nullPublishedStates,
  { type, status }
) => {
  switch (type) {
    case PUBLISHED_PAGE_STATES:
      return status;
    default:
      return state;
  }
};

export const VideoDetailBreadcrumb = (state = [], { type, data }) => {
  switch (type) {
    case SET_VIDEO_DETAIL_BREADCRUMB:
      return [...data];
    default:
      return state;
  }
};

export const videoUploadDetail = (state = {}, { type, data }) => {
  switch (type) {
    case SET_VIDEO_UPLOAD_DETAIL:
      return { ...data };
    default:
      return state;
  }
};

export const copyTranscriptReducer = (
  state = { text: "", loading: "", copied: "" },
  { type, data }
) => {
  switch (type) {
    case UPDATE_COPY:
      return { ...state, ...data };
    default:
      return state;
  }
};

const _nullvideoAnalysisState = {
  confirmationModal: false,
  videoId: "",
  loading: false,
  response: "",
  showAnalysisModal: false,
};

export const videoAnalysisStatus = (
  state = _nullvideoAnalysisState,
  { type, data }
) => {
  switch (type) {
    case UPDATE__REANALYSIS_FOR_VIDEO:
      return { ...state, ...data };
    case REQUEST_FOR_VIDEO_REANALYSIS:
      return { ...state, ...data, loading: data.loading, response: null };
    case RECIEVE_REANALYSIS_FOR_VIDEO:
      return {
        ...state,
        loading: data.loading,
        response: data.response,
      };
    default:
      return state;
  }
};
